import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";

import HeroSection from "./HeroSection";
const FeatureSection = lazy(() => import("./FeatureSection"));
const WorkflowSection = lazy(() => import("./WorkflowSection"));
const BenefitsSection = lazy(() => import("./BenefitsSection"));

const VeterinaryLIMS = () => {
  return (
    <>
      <Helmet>
        <title>
          Inventory Management System | Cloud-Based Laboratory Information Management System | Winglo
        </title>

        <meta
          name="description"
          content="Smart Veterinary LIMS for Accurate Animal Diagnostics."
        />

        <meta
          name="keywords"
          content="Manage animal samples, streamline lab workflows, and ensure accurate diagnostic results with a powerful cloud-based veterinary LIMS platform."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <FeatureSection />
         <WorkflowSection />
         <BenefitsSection />
      </Suspense>
    </>
  );
};

export default VeterinaryLIMS;
